import React from 'react';

function TodoEmpty() {
  return <p>¡Crea tu primer TODO!</p>;
}

export { TodoEmpty };